module.exports = __webpack_public_path__ + "img/docx.ebe13abb.png";